<script setup>
  import { Button } from "@/components/ui/button";
</script>

<template>
  <div
    class="flex min-h-[calc(100vh-120px)] w-full flex-col items-center justify-center"
    data-cy="not-found-page">
    <p class="heading-display">
      Oops, this page doesn't exist
    </p>
    <p class="mt-3 text-sm text-muted-foreground">The page may have been moved or deleted.</p>
    <Button
      class="mt-8"
      as="a"
      href="/">
      Back to dashboard
    </Button>
  </div>
</template>
